export default "__VITE_ASSET__lQ7Dr9ZZ__"